export default __webpack_public_path__ + "static/media/icon-child.82da548f.svg";